/**
 * @fileoverview POST handler for the "/email/ip_warming/:app_group_id/launch" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { emailIpWarmingAppGroupIdLaunchCacheKeys } from "./constants";
import type {
  PostEmailIpWarmingAppGroupIdLaunchProps,
  EmailIpWarmingLaunchResult,
  PostEmailIpWarmingLaunchResultErrors,
} from "./types";

export const postEmailIpWarmingLaunch = reactQueryMutationAdapter(
  emailIpWarmingAppGroupIdLaunchCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostEmailIpWarmingLaunchResultErrors>()(
    (props: PostEmailIpWarmingAppGroupIdLaunchProps): Promise<EmailIpWarmingLaunchResult> => {
      return fetch(
        `/email/ip_warming/${props.appGroupId}/launch${props.planId ? `/${props.planId}` : ""}`,
        "POST",
        props,
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
